import NextJsImage from 'next/image';

type ImageProps = React.ComponentProps<typeof NextJsImage>;

export const Image = ({ src, ...restProps }: ImageProps) => !!src && <NextJsImage {...restProps} src={src} />;
